import { render } from "./bigStory.vue?vue&type=template&id=6eb6bbb8&scoped=true"
import script from "./bigStory.vue?vue&type=script&lang=js"
export * from "./bigStory.vue?vue&type=script&lang=js"

import "./bigStory.vue?vue&type=style&index=0&id=6eb6bbb8&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/mFokeeiy/0/bpavone/detect-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb6bbb8"]])

export default __exports__